/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { I18NDataDto } from '../models/i-18-n-data-dto';
import { i18NGetI18NData } from '../fn/frontend-config/i-18-n-get-i-18-n-data';
import { I18NGetI18NData$Params } from '../fn/frontend-config/i-18-n-get-i-18-n-data';

@Injectable({ providedIn: 'root' })
export class FrontendConfigApiService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `i18NGetI18NData()` */
  static readonly I18NGetI18NDataPath = '/api/i18n/translations';

  /**
   * Get translation data.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `i18NGetI18NData()` instead.
   *
   * This method doesn't expect any request body.
   */
  i18NGetI18NData$Response(params?: I18NGetI18NData$Params, context?: HttpContext): Observable<StrictHttpResponse<I18NDataDto>> {
    const obs = i18NGetI18NData(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get translation data.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `i18NGetI18NData$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  i18NGetI18NData(params?: I18NGetI18NData$Params, context?: HttpContext): Observable<I18NDataDto> {
    const resp = this.i18NGetI18NData$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<I18NDataDto>): I18NDataDto => r.body)
    );
  }

}
